import {ADICIONAR_PESSOA_CORRETOR, 
        EDITAR_INFORMACOES_CORRETOR,
        REMOVER_PESSOA_CORRETOR,
        CARREGAR_CORRETORES_SERVER,
        CARREGAR_CORRETORES_STORE,
        REMOVER_PESSOA_CORRETOR_STORE,
        USUARIOS_LENGTH_ADD,
        USUARIOS_LENGTH_REMOVE} from '../constants/constants'

export const adicionarCorretor = (usuario, senha, telefones=[], nivel=1) =>({
    type : ADICIONAR_PESSOA_CORRETOR,
    id : Date.now(),
    usuario,
    telefones,
    senha,
    nivel
})

export const editarCorretor = (id, {usuario, senha, telefones=[], nivel=1}) => ({
    type : EDITAR_INFORMACOES_CORRETOR,
    id,
    data : {
        usuario,
        telefones,
        senha,
        nivel
    }
})

export const removerPessoaComoCorretor = (id)=>({
    type : REMOVER_PESSOA_CORRETOR,
    id
})

export const removerPessoaComoCorretorStore = (id) =>({
    type : REMOVER_PESSOA_CORRETOR_STORE, id
})

export const carregarCorretoresDoServer = () => ({
    type : CARREGAR_CORRETORES_SERVER    
})

export const carregarCorretoresNaStore = (corretores) => ({
    type : CARREGAR_CORRETORES_STORE,
    corretores
})

export const usuarioCount = (b=true) =>({
    type : b? USUARIOS_LENGTH_ADD : USUARIOS_LENGTH_REMOVE
})

window.adicionarCorretor = adicionarCorretor
window.editarCorretor = editarCorretor
window.removerPessoaComoCorretor = removerPessoaComoCorretor
window.carregarCorretoresDoServer = carregarCorretoresDoServer
window.carregarCorretoresNaStore = carregarCorretoresNaStore


// WEBPACK FOOTER //
// ./src/actions/corretores.js